import { IEvidence } from "../models";
import * as _ from "lodash"

export function Evidences({ evidences }: { evidences: IEvidence[] }) {
  return (
    <div>
      {_.isArray(evidences) && evidences.map((value, index) => {
        return (
          <div>
            <a href={value.response?.data?.[0]} target="_blank" rel="noreferrer">
              {value.name}
            </a>
          </div>
        );
      })}
    </div>
  );
}
